/** Two-letter monogram for ad/campaign imagery when no feature image is available. */
export function adMonogram(title: string, advertiserName: string): string {
    const primary = (title || '').trim();
    const fallback = (advertiserName || '').trim();
    const s = primary || fallback;
    if (!s) return '?';

    const words = s.split(/\s+/).filter(Boolean);
    if (words.length >= 2) {
        const a = words[0][0];
        const b = words[1][0];
        if (a && b) return `${a}${b}`.toUpperCase();
    }

    const word = words[0] || s;
    const letters = word.replace(/[^a-zA-Z0-9]/g, '');
    if (letters.length >= 2) return letters.slice(0, 2).toUpperCase();
    if (letters.length === 1) return `${letters[0]}${letters[0]}`.toUpperCase();
    if (word.length >= 2) return word.slice(0, 2).toUpperCase();
    return word[0]?.toUpperCase() || '?';
}
